<template>
  <div class="container">
    <div class="pt-3">
      <div class="mb-4 py-1">
        <span class="txt-grey-900 fs-24 fw-700">KYC</span>
      </div>
      <!-- // -->
      <div class="row">
        <!-- <div class="d-flex align-items-center m-3 border-bottom pb-2 mb-4">
                <a href="javascript:;" class="fs-18 txt-grey-600" @click="backToList">
                    KYC Board
                    <span class="spinner-border">
                    <span class="sr-only">Loading...</span>
                    </span>
                </a>
                <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="mx-2"
                >
                    <path
                    d="M8.29492 17.09L12.8749 12.5L8.29492 7.91L9.70492 6.5L15.7049 12.5L9.70492 18.5L8.29492 17.09Z"
                    fill="#667085"
                    />
                </svg>
                <a href="javascript:;" class="fs-18 txt-grey-900 mb-0 disabled mr-2">Từ ngày {{ formatDate(dates.start) }}  đến ngày  {{ formatDate(dates.end) }}</a>

                <div class="dropdown">
                    <div class="cursor-pointer" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 19.5C12.1978 19.5 12.3911 19.4414 12.5556 19.3315C12.72 19.2216 12.8482 19.0654 12.9239 18.8827C12.9996 18.7 13.0194 18.4989 12.9808 18.3049C12.9422 18.1109 12.847 17.9327 12.7071 17.7929C12.5673 17.653 12.3891 17.5578 12.1951 17.5192C12.0011 17.4806 11.8 17.5004 11.6173 17.5761C11.4346 17.6518 11.2784 17.78 11.1685 17.9444C11.0586 18.1089 11 18.3022 11 18.5C11 18.7652 11.1054 19.0196 11.2929 19.2071C11.4804 19.3946 11.7348 19.5 12 19.5ZM17 19.5C17.1978 19.5 17.3911 19.4414 17.5556 19.3315C17.72 19.2216 17.8482 19.0654 17.9239 18.8827C17.9996 18.7 18.0194 18.4989 17.9808 18.3049C17.9422 18.1109 17.847 17.9327 17.7071 17.7929C17.5673 17.653 17.3891 17.5578 17.1951 17.5192C17.0011 17.4806 16.8 17.5004 16.6173 17.5761C16.4346 17.6518 16.2784 17.78 16.1685 17.9444C16.0586 18.1089 16 18.3022 16 18.5C16 18.7652 16.1054 19.0196 16.2929 19.2071C16.4804 19.3946 16.7348 19.5 17 19.5ZM17 15.5C17.1978 15.5 17.3911 15.4414 17.5556 15.3315C17.72 15.2216 17.8482 15.0654 17.9239 14.8827C17.9996 14.7 18.0194 14.4989 17.9808 14.3049C17.9422 14.1109 17.847 13.9327 17.7071 13.7929C17.5673 13.653 17.3891 13.5578 17.1951 13.5192C17.0011 13.4806 16.8 13.5004 16.6173 13.5761C16.4346 13.6518 16.2784 13.78 16.1685 13.9444C16.0586 14.1089 16 14.3022 16 14.5C16 14.7652 16.1054 15.0196 16.2929 15.2071C16.4804 15.3946 16.7348 15.5 17 15.5ZM12 15.5C12.1978 15.5 12.3911 15.4414 12.5556 15.3315C12.72 15.2216 12.8482 15.0654 12.9239 14.8827C12.9996 14.7 13.0194 14.4989 12.9808 14.3049C12.9422 14.1109 12.847 13.9327 12.7071 13.7929C12.5673 13.653 12.3891 13.5578 12.1951 13.5192C12.0011 13.4806 11.8 13.5004 11.6173 13.5761C11.4346 13.6518 11.2784 13.78 11.1685 13.9444C11.0586 14.1089 11 14.3022 11 14.5C11 14.7652 11.1054 15.0196 11.2929 15.2071C11.4804 15.3946 11.7348 15.5 12 15.5ZM19 3.5H18V2.5C18 2.23478 17.8946 1.98043 17.7071 1.79289C17.5196 1.60536 17.2652 1.5 17 1.5C16.7348 1.5 16.4804 1.60536 16.2929 1.79289C16.1054 1.98043 16 2.23478 16 2.5V3.5H8V2.5C8 2.23478 7.89464 1.98043 7.70711 1.79289C7.51957 1.60536 7.26522 1.5 7 1.5C6.73478 1.5 6.48043 1.60536 6.29289 1.79289C6.10536 1.98043 6 2.23478 6 2.5V3.5H5C4.20435 3.5 3.44129 3.81607 2.87868 4.37868C2.31607 4.94129 2 5.70435 2 6.5V20.5C2 21.2956 2.31607 22.0587 2.87868 22.6213C3.44129 23.1839 4.20435 23.5 5 23.5H19C19.7956 23.5 20.5587 23.1839 21.1213 22.6213C21.6839 22.0587 22 21.2956 22 20.5V6.5C22 5.70435 21.6839 4.94129 21.1213 4.37868C20.5587 3.81607 19.7956 3.5 19 3.5ZM20 20.5C20 20.7652 19.8946 21.0196 19.7071 21.2071C19.5196 21.3946 19.2652 21.5 19 21.5H5C4.73478 21.5 4.48043 21.3946 4.29289 21.2071C4.10536 21.0196 4 20.7652 4 20.5V11.5H20V20.5ZM20 9.5H4V6.5C4 6.23478 4.10536 5.98043 4.29289 5.79289C4.48043 5.60536 4.73478 5.5 5 5.5H6V6.5C6 6.76522 6.10536 7.01957 6.29289 7.20711C6.48043 7.39464 6.73478 7.5 7 7.5C7.26522 7.5 7.51957 7.39464 7.70711 7.20711C7.89464 7.01957 8 6.76522 8 6.5V5.5H16V6.5C16 6.76522 16.1054 7.01957 16.2929 7.20711C16.4804 7.39464 16.7348 7.5 17 7.5C17.2652 7.5 17.5196 7.39464 17.7071 7.20711C17.8946 7.01957 18 6.76522 18 6.5V5.5H19C19.2652 5.5 19.5196 5.60536 19.7071 5.79289C19.8946 5.98043 20 6.23478 20 6.5V9.5ZM7 15.5C7.19778 15.5 7.39112 15.4414 7.55557 15.3315C7.72002 15.2216 7.84819 15.0654 7.92388 14.8827C7.99957 14.7 8.01937 14.4989 7.98079 14.3049C7.9422 14.1109 7.84696 13.9327 7.70711 13.7929C7.56725 13.653 7.38907 13.5578 7.19509 13.5192C7.00111 13.4806 6.80004 13.5004 6.61732 13.5761C6.43459 13.6518 6.27841 13.78 6.16853 13.9444C6.05865 14.1089 6 14.3022 6 14.5C6 14.7652 6.10536 15.0196 6.29289 15.2071C6.48043 15.3946 6.73478 15.5 7 15.5ZM7 19.5C7.19778 19.5 7.39112 19.4414 7.55557 19.3315C7.72002 19.2216 7.84819 19.0654 7.92388 18.8827C7.99957 18.7 8.01937 18.4989 7.98079 18.3049C7.9422 18.1109 7.84696 17.9327 7.70711 17.7929C7.56725 17.653 7.38907 17.5578 7.19509 17.5192C7.00111 17.4806 6.80004 17.5004 6.61732 17.5761C6.43459 17.6518 6.27841 17.78 6.16853 17.9444C6.05865 18.1089 6 18.3022 6 18.5C6 18.7652 6.10536 19.0196 6.29289 19.2071C6.48043 19.3946 6.73478 19.5 7 19.5Z" fill="#20419B"/>
                        </svg>
                    </div>
                    <div class="dropdown-menu border-radius-16px border-none" aria-labelledby="dropdownMenuButton">
                        <v-date-picker class="dropdown-item border-none hover-none" is-range v-model="dates" @input="onChange()" is-expanded/>
                    </div>
                </div>

        </div>-->
        <div
          class="col-md-4 col-xl-3 mb-3"
          v-for="kyc in kyc_list.data"
          :key="kyc.id"
          @click="getDetail(kyc)"
        >
          <div class="item-w d-flex justify-between">
            <div class="flex h-24">
              <div class="w-24 fs-24 fw-500 txt-black">{{ getTime(kyc.meeting_start_time) }}</div>
              <div class="break-words w-36">
                <p class="fs-16 fw-500 txt-grey-900 mb-1">{{ getDay(kyc.meeting_date) }}</p>
                <p class="fs-16 fw-500 txt-grey-900 mb-1">{{ kyc.doctor.name }}</p>
                <p class="fs-16 fw-500 txt-grey-900 mb-1">{{ kyc.work }}</p>
                <p class="fs-16 fw-500 txt-pri mb-1">{{ kyc.cs_user && kyc.cs_user.name }}</p>
              </div>
            </div>
            <div
              v-if="kyc && kyc.cs_user"
              class="mb-3 cursor-pointer"
              @click.stop="handleJoinRoom(kyc)"
            >
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.5625 6.54036L8.39583 7.70703L10.5625 9.8737H2.0625V11.5404H10.5625L8.39583 13.707L9.5625 14.8737L13.7292 10.707L9.5625 6.54036ZM17.0625 16.5404H10.3958V18.207H17.0625C17.9792 18.207 18.7292 17.457 18.7292 16.5404V4.8737C18.7292 3.95703 17.9792 3.20703 17.0625 3.20703H10.3958V4.8737H17.0625V16.5404Z"
                  fill="#20419B"
                />
              </svg>
            </div>
            <div v-else class="mb-3 cursor-pointer" @click.stop="handleAccept(kyc)">
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.7637 11.3338H15.097C14.876 11.3338 14.664 11.4216 14.5077 11.5779C14.3515 11.7342 14.2637 11.9462 14.2637 12.1672C14.2637 12.3882 14.3515 12.6002 14.5077 12.7564C14.664 12.9127 14.876 13.0005 15.097 13.0005H15.8553C15.6817 14.0225 15.1946 14.9653 14.4615 15.6984C13.7285 16.4314 12.7857 16.9185 11.7637 17.0922V9.66718H12.597C12.818 9.66718 13.03 9.57938 13.1863 9.4231C13.3425 9.26682 13.4303 9.05486 13.4303 8.83385C13.4303 8.61283 13.3425 8.40087 13.1863 8.24459C13.03 8.08831 12.818 8.00051 12.597 8.00051H11.7637V7.01718C12.3197 6.8206 12.7883 6.43379 13.0867 5.92511C13.3851 5.41644 13.4941 4.81865 13.3943 4.2374C13.2946 3.65615 12.9926 3.12888 12.5417 2.74876C12.0908 2.36864 11.5201 2.16016 10.9303 2.16016C10.3406 2.16016 9.76985 2.36864 9.31896 2.74876C8.86806 3.12888 8.56607 3.65615 8.46634 4.2374C8.36662 4.81865 8.47558 5.41644 8.77398 5.92511C9.07238 6.43379 9.54099 6.8206 10.097 7.01718V8.00051H9.26367C9.04266 8.00051 8.8307 8.08831 8.67442 8.24459C8.51814 8.40087 8.43034 8.61283 8.43034 8.83385C8.43034 9.05486 8.51814 9.26682 8.67442 9.4231C8.8307 9.57938 9.04266 9.66718 9.26367 9.66718H10.097V17.0922C9.07497 16.9185 8.13219 16.4314 7.39914 15.6984C6.66609 14.9653 6.17902 14.0225 6.00534 13.0005H6.76367C6.98469 13.0005 7.19665 12.9127 7.35293 12.7564C7.50921 12.6002 7.59701 12.3882 7.59701 12.1672C7.59701 11.9462 7.50921 11.7342 7.35293 11.5779C7.19665 11.4216 6.98469 11.3338 6.76367 11.3338H5.09701C4.87599 11.3338 4.66403 11.4216 4.50775 11.5779C4.35147 11.7342 4.26367 11.9462 4.26367 12.1672C4.26367 13.9353 4.96605 15.631 6.21629 16.8812C7.46654 18.1315 9.16223 18.8338 10.9303 18.8338C12.6984 18.8338 14.3941 18.1315 15.6444 16.8812C16.8946 15.631 17.597 13.9353 17.597 12.1672C17.597 11.9462 17.5092 11.7342 17.3529 11.5779C17.1966 11.4216 16.9847 11.3338 16.7637 11.3338ZM10.9303 5.50051C10.7655 5.50051 10.6044 5.45164 10.4674 5.36007C10.3303 5.2685 10.2235 5.13835 10.1604 4.98608C10.0974 4.83381 10.0809 4.66625 10.113 4.5046C10.1452 4.34295 10.2245 4.19447 10.3411 4.07792C10.4576 3.96138 10.6061 3.88201 10.7678 3.84986C10.9294 3.8177 11.097 3.83421 11.2492 3.89728C11.4015 3.96035 11.5317 4.06716 11.6232 4.2042C11.7148 4.34124 11.7637 4.50236 11.7637 4.66718C11.7637 4.88819 11.6759 5.10015 11.5196 5.25643C11.3633 5.41271 11.1514 5.50051 10.9303 5.50051Z"
                  fill="#20419B"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DetailKYC :kycID="idKycDetail" @reload="getKycList" />
  </div>
</template>

<script>
import DetailKYC from './DetailKYC.vue'
import appUtils from '../../../utils/appUtils'
export default {
  name: 'OperationList',
  components: { DetailKYC },
  data () {
    return {
      dates: {
        start: new Date(),
        end: new Date()
      },
      kyc_list: {},
      idKycDetail: null
    }
  },
  mounted () {
    this.getKycList()
  },
  methods: {
    async getKycList () {
      let self = this
      self.loading = true
      try {
        let params = {
          limit: 400,
          sort: 'created_at',
          sort_by: 'desc',
          page: 1
        }
        await self.$rf
          .getRequest('AdminRequest')
          .getKyc(params)
          .then(res => {
            self.kyc_list = res.data
          })
      } catch (e) {
        // statements
        console.log(e)
      } finally {
        self.loading = false
      }
    },
    backToList () {
      this.$router.push({ path: 'operation' })
    },
    formatDate (date) {
      return window.moment(date).format('DD/MM/YYYY')
    },
    getDetail (item) {
      this.idKycDetail = item.id
      window.$('#DetailKYC').modal('show')
    },
    getTime (item) {
      if (!item) return ''
      return window.moment(item, 'HH:mm:ss').format('HH:mm')
    },
    getDay (item) {
      if (!item) return ''
      return window.moment(item).format('DD/MM/YYYY')
    },
    handleJoinRoom (item) {
      let dm = ''
      if (process.env.NODE_ENV === 'development') {
        dm = 'https://dev.meet.hodo.com.vn/#/'
      } else {
        dm = 'https://meet.hodo.com.vn/#/'
      }
      let token = appUtils.getLocalToken()
      let routeData =
        dm + '_app/' + item.meet_room.room.room_name + '?token=' + token
      window.open(routeData, '_blank')
    },
    async handleAccept (item) {
      if (!item) return
      const data = await this.$rf
        .getRequest('AdminRequest')
        .putKycDetailJoin(item.id)
      this.$toast.open({
        message: 'Nhận thành công',
        type: 'success'
      })
      item = {
        ...item,
        ...data.data
      }
    }
  }
}
</script>

<style scoped>
.item-w {
  padding: 1rem;
  background-color: #fcfcfd;
  border-radius: 8px;
  border: 1.5px solid #20409b;
  cursor: pointer;
}
.border-radius-16px {
  border-radius: 16px;
}
.hover-none:hover {
  background-color: #ffffff;
}
</style>
